<template>
  <div class="core">
    <div class="core-top">
      <div class="top-select">
        <div style="margin-right: 0.7vw"><DropDown :content="warehouseTitle" :items="warehouse" @sendInfo = "showInfoW"></DropDown></div>
        <div style="margin-right: 0.7vw"><DropDown message="请选择仓库" :content="buildingTitle" :items="building" @sendInfo = "showInfoB"></DropDown></div>
        <div style="margin-right: 0.7vw"><DropDown message="请选择楼号" :content="floorTitle" :items="floor" @sendInfo = "showInfoF"></DropDown></div>
        <div style="margin-right: 0.7vw"><DropDown message="请选择层号" :content="areaTitle" :items="area" @sendInfo = "showInfoA"></DropDown></div>
        <div style="display: flex;flex-direction: row;align-items:center">
          <div class="query button" @click="functionA">查询</div>
        </div>
      </div>
    </div>
    <div class="core-bottom" style="position: relative;z-index: 9">
      <transition :name="transitionName">
        <router-view class="Router"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import click from '../../../tools/click'
import DropDown from '../../../components/DropDownSingle.vue'
import {warehouseNode} from '../../../api/basic'
export default {
  name: 'Warehouse',
  components: { DropDown },
  data () {
    return {
      transitionName: 'slide-fade',
      warehouse: [],
      building: [],
      floor: [],
      area: [],
      warehouseTitle: '请选择仓库',
      buildingTitle: '请选择楼号',
      floorTitle: '请选择层号',
      areaTitle: '请选择区号',
      siteId: '',
      siteType: '',
      itemList: [
        {title: '全部', sign: 1, path: '/warehouse'},
        {title: '传感器配置', sign: 0, path: '/warehouse/timeMonitoring/timeSensor'}
      ],
      maintainStageData: [
        {name: '全部养护阶段', value: ''},
        {name: '自然醇化阶段', value: '01'},
        {name: '防霉杀虫阶段', value: '02'},
        {name: '气调醇化阶段', value: '03'},
        {name: '气调保质阶段', value: '04'}
      ],
      maintainStage: '', // 养护阶段
      materialCode: '', // 烟草代码
      materialName: '' // 烟草名称
    }
  },
  created () {
    let body = {
      warehouseNodeId: '',
      warehouseNodeType: '01'
    }
    warehouseNode(body).then(res => {
      console.log(res)
      this.warehouse = res.data
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    functionA: function () {
      click.$emit('click_first', this.siteId, this.siteType, this.maintainStage, this.materialCode, this.materialName)
    },
    showInfoW: function (data) {
      console.log(data)
      this.warehouseTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: '02'
      }
      warehouseNode(body).then(res => {
        console.log(res)
        this.building = res.data
        this.buildingTitle = '请选择楼号'
        this.floor = []
        this.floorTitle = '请选择层号'
        this.area = []
        this.areaTitle = '请选择区号'
        this.stack = []
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoB: function (data) {
      this.buildingTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: '03'
      }
      warehouseNode(body).then(res => {
        console.log(res)
        this.floor = res.data
        this.floorTitle = '请选择层号'
        this.area = []
        this.areaTitle = '请选择区号'
        this.stack = []
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoF: function (data) {
      this.floorTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: '04'
      }
      warehouseNode(body).then(res => {
        console.log(res)
        this.area = res.data
        this.areaTitle = '请选择区号'
        this.stack = []
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoA: function (data) {
      this.areaTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      console.log(data)
    },
    showInfoS: function (data) {
      this.maintainStage = data.value
      console.log(this.maintainStage)
    }
  }
}
</script>

<style scoped>
  @import "Warehouse.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/warehouse/Warehouse.vue